import {platform} from "@/api/platform";
import {PERMISSIONS} from "@/constants";
import permissionsHelper from '@helpers_permissions';

export default {
    namespaced: true,
    state: {
        permissions: null,
        restrictions: null
    },
    getters: {
        permissions: state => state.permissions,
        restrictions: state => state.restrictions,
        hasPermission: state => (permission) => {

            return null !== state.permissions && -1 !== state.permissions.indexOf(permission);
        },
        hasRestriction: state => permission => {

            return state.restrictions
                && undefined !== state.restrictions[permission]
                && true === permissionsHelper.isRestricted(state.restrictions[permission])
        },
        getRestriction: state => permission => {

            if (state.restrictions && state.restrictions[permission]) {

                return state.restrictions[permission];
            }

            return {};
        },
        hasPermissionAccess: state => permission => null !== state.permissions
            && -1 !== state.permissions.indexOf(permission)
            && !(
                state.restrictions
                && undefined !== state.restrictions[permission]
                && true === permissionsHelper.isRestricted(state.restrictions[permission])
            )
    },
    mutations: {
        setPermissions: (state, permissions) => state.permissions = permissions,
        setRestrictions: (state, restrictions) => state.restrictions = restrictions,
    },
    actions: {
        setPermissions: (context, permissions) => context.commit("setPermissions", permissions),
        setRestrictions: (context, restrictions) => context.commit("setRestrictions", restrictions),
        refresh(context) {

            return platform
                .get(`/api/v2/consumers/${this.getters["user/id"]}`, {params: {get: "permissions,validationMap"}})
                .then(response => {

                    context.commit("setRestrictions", {[PERMISSIONS.EMPLOYEE]: response.data.results.validationMap})
                    context.commit(
                        "setPermissions",
                        this.getters["user/impersonatorToken"]
                            ? (-1 !== response.data.results.permissions.indexOf(PERMISSIONS.EMPLOYEE) ? [PERMISSIONS.EMPLOYEE] : [])
                            : response.data.results.permissions
                    )
                })
        },
        clear: (context) => {

            context.commit("setPermissions", null);
            context.commit("setRestrictions", null);
        }
    }
}